import httpClient from '@/http-client'

export const get = (Options = {}) => {
	return httpClient
		.get("/api/v1/service-quotations", Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
	return httpClient
		.get(`/api/v1/service-quotations/${id}`, Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const store = data => {
	return httpClient
		.post('/api/v1/service-quotations', data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
	return httpClient
		.put(`/api/v1/service-quotations/${id}`, data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const updateStatus = (id, data) => {
	return httpClient
		.put(`/api/v1/service-quotations/update-status/${id}`, data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const updateChargeStatus = (id, data) => {
	return httpClient
		.put(`/api/v1/service-quotations/update-charge-status/${id}`, data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
	return httpClient
		.delete(`/api/v1/service-quotations/${id}`)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const previewPdf = id => {
	return httpClient
		.get(`/api/v1/service-quotations/${id}/preview-pdf`)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
	return httpClient
		.get(`/api/v1/service-quotations/form-view-models`, Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export default {
	get,
	find,
	store,
	update,
	updateStatus,
	updateChargeStatus,
	destroy,
	previewPdf,
	formViewModel,
}